import { GameData } from ".";

export const demoGame: GameData = {
    initialSceneId: "intro",
    scenes: {
        intro: {
            id: "intro",
            video: "game/barLoop.mp4",
            loop: "game/barLoop.mp4",
            elements: {
                left: {
                    id: "btnLeft",
                    type: "button",
                    text: "Left",
                    style: {
                        position: "absolute",
                        left: "2em",
                        top: "50%",
                        transform: "translateY(-50%)",
                    },
                    triggers: {
                        onClick: {
                            type: "onClick",
                            action: {
                                type: "switchScene",
                                sceneId: "leftScene",
                            },
                        },
                    },
                },
                right: {
                    id: "btnRight",
                    type: "button",
                    text: "Right",
                    style: {
                        position: "absolute",
                        right: "2em",
                        top: "50%",
                        transform: "translateY(-50%)",
                    },
                    triggers: {
                        onClick: {
                            type: "onClick",
                            action: {
                                type: "switchScene",
                                sceneId: "rightScene",
                            },
                        },
                    },
                },
            },
        },
        leftScene: {
            id: "leftScene",
            video: "demo/intro.mp4",
            elements: {
                sicho: {
                    id: "sicho",
                    type: "singleChoice",
                    question: "Ge was geht?",
                    answers: [
                        {
                            id: "sichoA1",
                            text: "Guad is",
                            action: {
                                type: "switchScene",
                                sceneId: "intro",
                            },
                        },
                        {
                            id: "sichoA2",
                            text: "Na nix is",
                            action: {
                                type: "switchScene",
                                sceneId: "leftScene",
                            },
                        },
                        {
                            id: "sichoA3",
                            text: "Schleich di",
                            action: {
                                type: "switchScene",
                                sceneId: "rightScene",
                            },
                        },
                    ],
                },
            },
        },
        rightScene: {
            id: "rightScene",
            video: "demo/intro.mp4",
        },
    },
};
